import auth from '/@/plugins/auth'
import { computed, InjectionKey, ref } from 'vue'
import { ActionTree, createStore, GetterTree, MutationTree, Store, StoreOptions, useStore } from 'vuex'
import { EDeviceTypeName, ELocalStorageKey, ERouterName } from '../types'
import { Device, DeviceHms, DeviceOsd, DeviceStatus, DockOsd, GatewayOsd, OSDVisible } from '../types/device'
import { getNewElementGroupsReq, getLayers } from '/@/api/layer'
import { LayerType } from '/@/types/mapLayer'
import { WaylineFile } from '/@/types/wayline'
import { DevicesCmdExecuteInfo } from '/@/types/device-cmd'
import { getDeviceTopo, getNearestDeviceNew } from '../api/manage'
import * as Cesium from 'cesium'
import { dynamicRoutes, routes } from '/@/router/index'
import Layout from '/@/pages/page-web/home.vue'
import ParentView from '/@/pages/page-web/projects/workspace.vue'
import SLayout from '/@/pages/page-web/scenarios/index.vue'
import SParentView from '/@/pages/page-web/scenarios/scenario.vue'
import LiveAgora from '/@/components/livestream-agora.vue'
import LiveOthers from '/@/components/livestream-others.vue'
import ScenarioPaneDetail from '/@/pages/page-web/scenarios/plan_detail.vue'
// 修改导入语句，只使用coordinate.ts中实际存在的函数
import {
  decimalToDms,
  dmsToDecimal,
  calculateCesiumPolygonInfo,
  calculateCesiumCircleInfo,
  createCesiumCircle,
  CesiumCartographic,
  calculateCesiumPolygonArea,
  calculateCesiumPolygonPerimeter,
  calculateCesiumPolygonHeightDifferenceCartographic,
  latLonArrayToCartographicArray,
  degreesToRadians,
  latLonToCartographic,
  calculateGeodesicDistance,
  calculateCesiumPolylineLength
} from '../utils/coordinate'
import { getFlightAreaListData } from '../api/flight-area'
import { message, notification } from 'ant-design-vue'
import { getCrawlerGetAll, getNewCloudModel } from '../api/algCode'
import { getRouters } from '../api/menu'

const modules = import.meta.glob('../../src/pages/**/*.vue')

interface DeviceInfo {
  dock_sn: string;
  device_sn: string;
  nodeType: 'dock' | 'device';
}

const initStateFunc = () => ({
  Layers: [
    {
      name: 'default',
      id: '',
      is_distributed: true,
      elements: [],
      is_check: false,
      is_select: false,
      type: 1
    },
    {
      name: 'share',
      id: '',
      is_distributed: true,
      elements: [],
      is_check: false,
      is_select: false,
      type: 2
    }
  ],
  layerBaseInfo: {} as {
    [key: string]: string
  },
  drawVisible: false,
  livestreamOthersVisible: false,
  livestreamAgoraVisible: false,
  coverMap: {} as {
    [key: string]: any[]
  },
  wsEvent: {
    mapElementCreat: {},
    mapElementUpdate: {},
    mapElementDelete: {}
  },
  deviceStatusEvent: {
    deviceOnline: {} as DeviceStatus,
    deviceOffline: {} as DeviceStatus
  },
  markerInfo: {
    coverMap: {} as {
      [sn: string]: any
    },
    pathMap: {} as {
      [sn: string]: any[]
    }
  },
  deviceState: {
    // remote controller, dock
    gatewayInfo: {} as {
      [sn: string]: GatewayOsd
    },
    // drone
    deviceInfo: {} as {
      [sn: string]: DeviceOsd
    },
    dockInfo: {} as {
      [sn: string]: DockOsd
    },
    currentSn: '',
    currentType: -1
  },
  osdVisible: { // osd 显示设备相关信息
    sn: '',
    callsign: '',
    model: '',
    visible: false,
    gateway_sn: '',
    is_dock: false,
    payloads: null
  } as OSDVisible,
  waylineInfo: {

  } as WaylineFile,
  editWaylineInfo: {} as WaylineFile,

  dockInfo: {

  } as Device,
  pilotInfo: [],
  algorithmInfo: [],
  specialInfo: [],
  dockList: [] as Device[],
  hmsInfo: {} as {
    [sn: string]: DeviceHms[]
  },
  // 机场指令执行状态信息
  devicesCmdExecuteInfo: {
  } as DevicesCmdExecuteInfo,
  mqttState: null as any, // mqtt 实例
  clientId: '', // mqtt 连接 唯一客户端id
  flyControl: false,
  // 地图单例存储
  cesiumManagerInfo: null,
  // 操作类型
  operateType: '',
  // 航点点位数组
  entitiesPointOption: [],
  // 当前选中航点信息
  currPointInfo: null,
  location: {
    lat: 0,
    lon: 0,
    code: '',
    name: ''
  },
  mousePosition: null,
  selectDrawing: null,
  showEditRouter: false,
  headerVisible: true,
  editRouteList: [],
  mapKeyCodeList: [],
  editInfo: {},
  currentRoutePosIndex: null as null | number,
  editCurrentPoint: null,
  startPointFlag: false,
  routeStartPosition: null,
  aiAlgorithmConfigUpperLimit: false,
  isUseGlobalHeight: 0,
  defaultRouteData: {
    payloadLensIndex: [
      'wide',
      'zoom'
    ],
    imageFormat: [
      'wide',
      'zoom'
    ],
    globalTransitionalSpeed: 15,
    flyToWaylineMode: 'safely',
    takeOffSecurityHeight: 20,
    heightMode: 'EGM96',
    globalRTHHeight: 100,
    globalHeight: 100,
    autoFlightSpeed: 10,
    waypointTurnMode: 'toPointAndStopWithDiscontinuityCurvature',
    waypointHeadingMode: 'followWayline',
    gimbalPitchMode: 'manual',
    finishAction: 'goHome',
    orientedPhotoMode: false,
    autoRerouteInfo: false
  },
  defaultPlanarRouteSettingData: {
    acquisitionType: 'mapping2d',
    imageFormat: ['wide'],
    shootType: 'time',
    autoFlightSpeed: 8,
    heightMode: 'EGM96',
    globalHeight: 100,
    GSD: 5,
    irGSD: 5,
    orthoLidarOverlapW: 70,
    margin: 0,
    finishAction: 'goHome',
    flyToWaylineMode: 'safely',
    takeOffSecurityHeight: 20,
    distance: 0,
    duration: 0,
    area: 0,
    mapping3dRouteIndex: 1
  },
  defaultStripRouteSettingData: {
    acquisitionType: '',
    leftExpandDis: 50,
    rightExpandDis: 50,
    allExpandDis: 50,
    imageFormat: ['wide', 'zoom'],
    shootType: 'time',
    stripRouteType: 1,
    autoFlightSpeed: 10,
    heightMode: 'EGM96',
    globalHeight: 100,
    minGlobalHeight: 100,
    GSD: 5,
    irGSD: 5,
    minGSD: 5,
    minIrGSD: 5,
    orthoLidarOverlapW: 70,
    finishAction: 'goHome',
    flyToWaylineMode: 'safely',
    takeOffSecurityHeight: 20,
    routeDistance: 0,
    centerLineDistance: 0,
    duration: 0,
    area: 0,
    isUnite: true
  },
  mapPhotoInfoList: [],
  notieList: [],
  showPoint: false,
  currentPoint: {},
  showPolyline: false,
  currentPolyline: {},
  showPolygon: false,
  currentPolygon: {},
  showCircle: false,
  currentCircle: {},
  markList: [],
  custumFlyList: [],
  workspaceList: [],
  customWorkspace: localStorage.getItem(ELocalStorageKey.WorkspaceId) || '',
  crawlerList: [],
  selectedDeviceInfo: {
    dock_sn: '',
    device_sn: '',
    nodeType: 'dock'
  } as DeviceInfo,
  isFlyArea: true,
  isCustumFlyArea: true,
  isAirFly: false,
  airFlyList: [],
  cloudModel: {},
  flyToPointRow: {
    lon: '',
    lat: ''
  },
  flyErrorStatus: true,
  flyWarningStatus: true,
  flyPrimaryStatus: true,
  headSn: '',
  waylineTemplate: false,
  waylineDevice: false,
  isFromCreatePlan: false,
  waylinePilot: false,
  waylineAlgorithm: false,
  waylineSpecial: false,
  showPointCloud: false,
  showModelTileset: false,
  collapsed: true,
  FlightSimulationFlag: false,
  routes: [],
  addRoutes: [],
  defaultRoutes: [],
  topbarRouters: [],
  topbarRouter: [],
  sidebarRouters: [],
  scenariosSidebarRouters: [],
  homeRoutes: [],
  permissions: [] as string[],
  hasAddedAsyncRoutes: false,
  datacenter: true,
  currentPath: 'login',
  planarAllRoutes: [],
  planarStartPoint: null,
  planarPolygon: [],
  planarIndex: 0,
  isShowMask: true,
  photoPrecent: '',
  isLockMode: false
})

export type RootStateType = ReturnType<typeof initStateFunc>

const getters: GetterTree<RootStateType, RootStateType> = {
  permissions: (state) => state.permissions,
  routes: (state) => state.routes,
  addRoutes: (state) => state.addRoutes,
  defaultRoutes: (state) => state.defaultRoutes,
  topbarRouters: (state) => state.topbarRouters,
  sidebarRouters: (state) => state.sidebarRouters,
  scenariosSidebarRouters: (state) => state.scenariosSidebarRouters,
  homeRoutes: (state) => state.homeRoutes
}

// 辅助函数：将坐标数组转换为CesiumCartographic数组
const convertCoordinatesToCartographic = (coordinates: number[][]): CesiumCartographic[] => {
  return coordinates.map(coord =>
    latLonToCartographic(coord[0], coord[1], coord[2] || 0)
  )
}

// 修改 calculatePolylineHeightDiff 函数
const calculatePolylineHeightDiff = (coordinates: number[][]): number => {
  if (coordinates.length < 2) return 0
  let totalDiff = 0
  // 将坐标转换为Cartographic格式
  const cartographicPositions = latLonArrayToCartographicArray(coordinates)
  for (let i = 0; i < cartographicPositions.length - 1; i++) {
    const height1 = cartographicPositions[i].height
    const height2 = cartographicPositions[i + 1].height
    totalDiff += Math.abs(height1 - height2)
  }
  return totalDiff
}

// 修改 calculatePolylineLength 函数
export const calculatePolylineLength = (coordinates: number[][]): number => {
  if (coordinates.length < 2) return 0
  let totalLength = 0
  // 将坐标转换为Cartographic格式
  const cartographicPositions = latLonArrayToCartographicArray(coordinates)
  totalLength = calculateCesiumPolylineLength(cartographicPositions)
  return totalLength
}

// 辅助函数：计算多边形高度信息
const calculatePolygonHeightInfo = (coordinates: number[][]): { heightDifference: number; minHeight: number; maxHeight: number; averageHeight: number; } => {
  if (coordinates.length === 0) {
    return { heightDifference: 0, minHeight: 0, maxHeight: 0, averageHeight: 0 }
  }
  let minHeight = coordinates[0][2] || 0
  let maxHeight = coordinates[0][2] || 0
  let totalHeight = 0
  for (const coord of coordinates) {
    const height = coord[2] || 0
    if (height < minHeight) minHeight = height * 1
    if (height > maxHeight) maxHeight = height * 1
    totalHeight += height * 1
  }
  const averageHeight = totalHeight / coordinates.length
  const cartographicPositions = latLonArrayToCartographicArray(coordinates)
  const heightDifference = calculateCesiumPolygonHeightDifferenceCartographic(cartographicPositions)
  return { heightDifference, minHeight, maxHeight, averageHeight }
}

// 辅助函数：计算多边形的质心
const calculatePolygonCentroid = (coordinates: number[][]): { longitude: number; latitude: number; height: number } => {
  if (coordinates.length === 0) {
    return { longitude: 0, latitude: 0, height: 0 }
  }

  let sumLon = 0; let sumLat = 0; let sumHeight = 0

  for (const coord of coordinates) {
    sumLon += coord[0]
    sumLat += coord[1]
    sumHeight += coord[2] || 0
  }

  return {
    longitude: sumLon / coordinates.length,
    latitude: sumLat / coordinates.length,
    height: sumHeight / coordinates.length
  }
}

const mutations: MutationTree<RootStateType> = {
  SET_SHOW_MASK (state, val) {
    state.isShowMask = val
  },
  SET_PLANAR_START_POINT (state, startPoint) {
    state.planarStartPoint = startPoint
  },
  SET_PLANAR_POLYGON (state, polygon) {
    state.planarPolygon = polygon
  },
  SET_PLANAR_INDEX (state, index: number) {
    state.planarIndex = index
  },
  SET_PLANAR_ALL_ROUTES (state, routes: any[]) {
    state.planarAllRoutes = routes
  },
  SET_PATH (state, path: string) {
    state.currentPath = path
  },
  SET_DATACENTER (state, flag: boolean) {
    state.datacenter = flag
  },
  SET_PERMISSIONS: (state, permissions:string[]) => {
    state.permissions = permissions
  },
  SET_FLIGHT_SIMULATION (state, flag: boolean) {
    state.FlightSimulationFlag = flag
  },
  SET_COLLAPSED (state, flag: boolean) {
    state.collapsed = flag
  },
  SET_POINT_CLOUD (state, flag: boolean) {
    state.showPointCloud = flag
  },
  SET_MODEL_TILESET (state, flag: boolean) {
    state.showModelTileset = flag
  },
  SET_WAYLINE_TEMPLATE (state, flag: boolean) {
    state.waylineTemplate = flag
  },
  SET_WAYLINE_DEVICE (state, flag: boolean) {
    state.waylineDevice = flag
  },
  SET_WAYLINE_PILOT (state, flag: boolean) {
    state.waylinePilot = flag
  },
  SET_WAYLINE_ALGORITHM (state, flag: boolean) {
    state.waylineAlgorithm = flag
  },
  SET_WAYLINE_SPECIAL (state, flag: boolean) {
    state.waylineSpecial = flag
  },
  SET_IS_FROM_CREATE_PLAN (state, flag: boolean) {
    state.isFromCreatePlan = flag
  },
  SET_FLY_ERROR_STATUS (state, flag: boolean) {
    state.flyErrorStatus = flag
  },
  SET_FLY_WARNING_STATUS (state, flag: boolean) {
    state.flyWarningStatus = flag
  },
  SET_FLY_PRIMARY_STATUS (state, flag: boolean) {
    state.flyPrimaryStatus = flag
  },

  SET_AIR_FLY (state, flag: boolean) {
    state.isAirFly = flag
    if (!flag) {
      state.flyToPointRow = { lon: '', lat: '' }
    }
  },
  SET_AIR_FLY_LIST (state, list) {
    state.airFlyList = list
  },
  SET_CUSTUM_FLY_AREA_FLAG (state, flag: boolean) {
    state.isCustumFlyArea = flag
  },
  SET_FLY_AREA_FLAG (state, flag: boolean) {
    state.isFlyArea = flag
  },
  SET_SELECTED_DEVICE_INFO (state, info: DeviceInfo) {
    state.selectedDeviceInfo = info
  },
  SET_MARK_LIST (state, list) {
    state.markList = list
  },
  SET_FLY_LIST (state, list) {
    state.custumFlyList = list
  },
  SET_WORKSPACE_LIST (state, list) {
    state.workspaceList = list
  },
  /**
   * 设置爬虫列表
   *
   * @param {any} state - Vuex状态对象
   * @param {any[]} list - 爬虫列表数据
   */
  SET_CRAWLER_LIST (state, list) {
    state.crawlerList = list
  },
  SET_CLOUD_MODEL (state, obj) {
    state.cloudModel = obj
  },
  SET_MARK_CURRENT (state, info) {
    state.showPoint = false
    state.showPolyline = false
    state.showPolygon = false
    state.showCircle = false
    state.currentPoint = {}
    state.currentPolyline = {}
    state.currentPolygon = {}
    state.currentCircle = {}

    switch (info.type) {
      case 'Point':
        state.showPoint = true
        state.currentPoint = {
          id: info.id,
          localName: info.name,
          color: info.resource.content.properties.color,
          coordinateMode: 'decimal',
          decimalLongitude: info.resource.content.geometry.coordinates[0],
          dmsLongitude: decimalToDms(info.resource.content.geometry.coordinates[0]),
          decimalLatitude: info.resource.content.geometry.coordinates[1],
          dmsLatitude: dmsToDecimal(info.resource.content.geometry.coordinates[1]),
          height: info.resource.content.geometry.coordinates[2],
          creator: info.resource.user_name
        }
        break
      case 'Polyline': {
        state.showPolyline = true

        // 计算折线长度
        const length = calculatePolylineLength(info.resource.content.geometry.coordinates)

        // 计算高度差
        const heightDiff = calculatePolylineHeightDiff(info.resource.content.geometry.coordinates)

        state.currentPolyline = {
          id: info.id,
          localName: info.name,
          color: info.resource.content.properties.color,
          coordinates: info.resource.content.geometry.coordinates,
          creator: info.resource.user_name,
          // 使用Cesium距离计算
          horizontalDistance: length,
          // 折线没有直线距离的概念，这里设为相同值
          straightDistance: length,
          heightDifference: heightDiff
        }
        break
      }
      case 'Polygon': {
        state.showPolygon = true

        // 将坐标转换为Cartographic格式
        const cartographicPositions = convertCoordinatesToCartographic(info.resource.content.geometry.coordinates[0])
        if (cartographicPositions[0] !== cartographicPositions[cartographicPositions.length - 1]) {
          cartographicPositions.push(cartographicPositions[0])
        }
        // 计算多边形信息
        const area = calculateCesiumPolygonArea(cartographicPositions)
        const perimeter = calculateCesiumPolygonPerimeter(cartographicPositions)
        const heightDifference = calculateCesiumPolygonHeightDifferenceCartographic(cartographicPositions)

        // 计算高度信息
        const heightInfo = calculatePolygonHeightInfo(info.resource.content.geometry.coordinates)
        // 计算质心
        const centroid = calculatePolygonCentroid(info.resource.content.geometry.coordinates)

        state.currentPolygon = {
          id: info.id,
          localName: info.name,
          color: info.resource.content.properties.color,
          coordinates: info.resource.content.geometry.coordinates,
          creator: info.resource.user_name,
          // 使用测地面积和测地周长
          localHeightDifference: heightInfo.heightDifference,
          localHorizontalArea: area,
          localHorizontalPerimeter: perimeter,
          // 添加高度统计信息
          minHeight: heightInfo.minHeight,
          maxHeight: heightInfo.maxHeight,
          averageHeight: heightInfo.averageHeight,
          // 保留质心信息
          centroid: {
            longitude: centroid.longitude,
            latitude: centroid.latitude,
            height: centroid.height
          }
        }
        break
      }
      case 'Circle': {
        state.showCircle = true

        // 创建Cesium圆形
        const circle = createCesiumCircle(
          info.resource.content.geometry.coordinates[0], // 经度
          info.resource.content.geometry.coordinates[1], // 纬度
          info.resource.content.geometry.radius, // 半径
          info.resource.content.geometry.coordinates[2] || 0 // 高度
        )

        // 计算圆形信息
        const circleInfo = calculateCesiumCircleInfo(circle)

        state.currentCircle = {
          id: info.id,
          localName: info.name,
          color: info.resource.content.properties.color,
          coordinates: info.resource.content.geometry.coordinates,
          longitude: circle.resource.content.geometry.coordinates[0],
          latitude: circle.resource.content.geometry.coordinates[1],
          height: circle.resource.content.geometry.coordinates[2] || 0,
          radius: circle.resource.content.geometry.radius,
          creator: info.resource.user_name,
          // 使用测地面积和测地周长
          horizontalArea: circleInfo.area,
          horizontalPerimeter: circleInfo.circumference,
        }
        break
      }
    }
  },
  SET_SHOW_POINT (state, flag) {
    state.showPoint = flag
    state.showPolyline = false
    state.showPolygon = false
    state.showCircle = false
  },
  SET_CURRENT_POINT (state, point) {
    if (Object.keys(point).length === 0) {
      state.currentPoint = {}
      return
    }
    state.currentPoint = {
      id: point.id,
      localName: point.name,
      color: point.resource.content.properties.color,
      coordinateMode: point.resource.content.coordinateMode || 'decimal',
      decimalLongitude: point.resource.content.geometry.coordinates[0],
      dmsLongitude: decimalToDms(point.resource.content.geometry.coordinates[0]),
      decimalLatitude: point.resource.content.geometry.coordinates[1],
      dmsLatitude: decimalToDms(point.resource.content.geometry.coordinates[1]),
      height: point.resource.content.geometry.coordinates[2],
      creator: point.resource.user_name
    }
  },
  SET_SHOW_POLYLINE (state, flag) {
    state.showPolyline = flag
    state.showPoint = false
    state.showPolygon = false
    state.showCircle = false
  },
  SET_CURRENT_POLYLINE (state, polyline) {
    if (Object.keys(polyline).length === 0) {
      state.currentPolyline = {}
      return
    }

    // 计算折线长度
    const length = calculatePolylineLength(polyline.resource.content.geometry.coordinates)

    // 计算高度差
    const heightDiff = calculatePolylineHeightDiff(polyline.resource.content.geometry.coordinates)

    state.currentPolyline = {
      id: polyline.id,
      localName: polyline.name,
      color: polyline.resource.content.properties.color,
      coordinates: polyline.resource.content.geometry.coordinates,
      creator: polyline.resource.user_name,
      // 使用Cesium距离计算
      horizontalDistance: length,
      // 折线没有直线距离的概念，这里设为相同值
      straightDistance: length,
      heightDifference: heightDiff || 0
    }
  },
  SET_SHOW_POLYGON (state, flag) {
    state.showPolygon = flag
    state.showPoint = false
    state.showPolyline = false
    state.showCircle = false
  },
  SET_CURRENT_POLYGON (state, polygon) {
    if (Object.keys(polygon).length === 0) {
      state.currentPolygon = {}
      return
    }

    // 将坐标转换为Cartographic格式
    const cartographicPositions = convertCoordinatesToCartographic(polygon.resource.content.geometry.coordinates[0])

    // 计算多边形信息
    const area = calculateCesiumPolygonArea(cartographicPositions)
    const perimeter = calculateCesiumPolygonPerimeter(cartographicPositions)
    const heightDifference = calculateCesiumPolygonHeightDifferenceCartographic(cartographicPositions)

    // 计算高度信息
    const heightInfo = calculatePolygonHeightInfo(polygon.resource.content.geometry.coordinates)
    // 计算质心
    const centroid = calculatePolygonCentroid(polygon.resource.content.geometry.coordinates)

    state.currentPolygon = {
      id: polygon.id,
      localName: polygon.name,
      color: polygon.resource.content.properties.color,
      coordinates: polygon.resource.content.geometry.coordinates,
      creator: polygon.resource.user_name,
      // 使用测地面积和测地周长
      localHeightDifference: heightDifference,
      localHorizontalArea: area,
      localHorizontalPerimeter: perimeter,
      // 添加高度统计信息
      minHeight: heightInfo.minHeight,
      maxHeight: heightInfo.maxHeight,
      averageHeight: heightInfo.averageHeight,
      // 保留质心信息
      centroid: {
        longitude: centroid.longitude,
        latitude: centroid.latitude,
        height: centroid.height
      }
    }
  },
  SET_SHOW_CIRCLE (state, flag) {
    state.showCircle = flag
    state.showPoint = false
    state.showPolyline = false
    state.showPolygon = false
  },
  SET_CURRENT_CIRCLE (state, circle) {
    if (Object.keys(circle).length === 0) {
      state.currentCircle = {}
      return
    }

    // 创建Cesium圆形
    const cesiumCircle = createCesiumCircle(
      circle.resource.content.geometry.coordinates[0], // 经度
      circle.resource.content.geometry.coordinates[1], // 纬度
      circle.resource.content.geometry.radius, // 半径
      circle.resource.content.geometry.coordinates[2] || 0 // 高度
    )

    // 计算圆形信息
    const circleInfo = calculateCesiumCircleInfo(cesiumCircle)

    state.currentCircle = {
      id: circle.id,
      localName: circle.name,
      color: circle.resource.content.properties.color,
      coordinates: circle.resource.content.geometry.coordinates,
      longitude: circle.resource.content.geometry.coordinates[0],
      latitude: circle.resource.content.geometry.coordinates[1],
      radius: circle.resource.content.geometry.radius,
      creator: circle.resource.user_name,
      // 使用测地面积和测地周长
      horizontalArea: circleInfo.area,
      horizontalPerimeter: circleInfo.circumference,
      // 圆形通常没有高度差，除非有地形数据
      heightDifference: 0,
      // 添加高度信息
      height: circle.resource.content.geometry.coordinates[2] || 0,
    }
  },
  SET_NOTIE_LIST (state, list) {
    state.notieList = list
  },
  SET_MAP_PHOTO_INFO_LIST (state, list) {
    state.mapPhotoInfoList = list
  },
  SET_MAP_KEY_CODE_LIST (state, list) {
    state.mapKeyCodeList = list
  },
  SET_EDIT_INFO (state, info) {
    state.editInfo = info
  },
  SET_START_POINT_POSITION (state, position) {
    state.routeStartPosition = position
  },
  SET_START_POINT_FLAG (state, flag) {
    state.startPointFlag = flag
  },
  SET_EDIT_CURRENT_POINT (state, point) {
    state.editCurrentPoint = point
  },
  SET_EDIT_ROUTER_LIST (state, list) {
    state.editRouteList = list
  },
  SET_HEADER_VISIBLE (state, flag: boolean) {
    state.headerVisible = flag
  },
  SET_EDIT_WAYLINE_INFO (state, info) {
    state.editWaylineInfo = info
  },
  SET_EDIT_ROUTER (state, flag) {
    state.showEditRouter = flag
  },
  SET_MOUSE_POSITION (state, postion) {
    state.mousePosition = postion
  },
  SET_SELECTED_DRAWING (state, data) {
    state.selectDrawing = data
  },
  SET_LOCATION (state, info) {
    state.location.lat = Number(info.workspace_lan)
    state.location.lon = Number(info.workspace_lon)
    state.location.code = info.workspace_code
    state.location.name = info.workspace_name
  },
  SET_DOCK_DEVICE_LIST (state, list) {
    state.dockList = list
  },
  SET_OPERATE_TYPE (state, val) {
    if (state.operateType && state.operateType === val) {
      state.operateType = ''
    } else {
      state.operateType = val
    }
  },
  SET_ENTITIES_POINT_OPTION (state, val) {
    console.log('entitiesPointOption数据更新')
    state.entitiesPointOption = [...val]
  },
  SET_CURRPOINT_INFO (state, val) {
    state.currPointInfo = val
  },
  SET_CESIUM_MANAGER_INFO (state, val) {
    state.cesiumManagerInfo = val
  },
  SET_LAYER_INFO (state, info) {
    state.Layers = info
  },
  CAMERA_PHOTO_TAKE_PROGRESS (state, info) {
    state.photoPrecent = info.message
  },
  SET_DEVICE_INFO (state, info) {
    state.deviceState.deviceInfo[info.sn] = info.host
    state.deviceState.currentSn = info.sn
    state.deviceState.currentType = EDeviceTypeName.Aircraft
  },
  SET_GATEWAY_INFO (state, info) {
    state.deviceState.gatewayInfo[info.sn] = info.host
    state.deviceState.currentSn = info.sn
    state.deviceState.currentType = EDeviceTypeName.Gateway
  },
  SET_DOCK_INFO (state, info) {
    if (Object.keys(info.host).length === 0) {
      return
    }
    if (!state.deviceState.dockInfo[info.sn]) {
      state.deviceState.dockInfo[info.sn] = {} as DockOsd
    }
    state.deviceState.currentSn = info.sn
    state.deviceState.currentType = EDeviceTypeName.Dock
    const dock = state.deviceState.dockInfo[info.sn]
    if (info.host.mode_code !== undefined) {
      dock.basic_osd = info.host
      return
    }
    if (info.host.wireless_link) {
      dock.link_osd = info.host
      return
    }
    if (info.host.job_number !== undefined) {
      dock.work_osd = info.host
    }
  },
  SET_DRAW_VISIBLE_INFO (state, bool) {
    state.drawVisible = bool
  },
  SET_LIVESTREAM_OTHERS_VISIBLE (state, bool) {
    state.livestreamOthersVisible = bool
  },
  SET_LIVESTREAM_AGORA_VISIBLE (state, bool) {
    state.livestreamAgoraVisible = bool
  },
  SET_MAP_ELEMENT_CREATE (state, info) {
    state.wsEvent.mapElementCreat = info
  },
  SET_MAP_ELEMENT_UPDATE (state, info) {
    state.wsEvent.mapElementUpdate = info
  },
  SET_MAP_ELEMENT_DELETE (state, info) {
    state.wsEvent.mapElementDelete = info
  },
  SET_DEVICE_ONLINE (state, info) {
    state.deviceStatusEvent.deviceOnline = info
  },
  SET_DEVICE_OFFLINE (state, info) {
    state.deviceStatusEvent.deviceOffline = info
    delete state.deviceState.gatewayInfo[info.sn]
    delete state.deviceState.deviceInfo[info.sn]
    delete state.deviceState.dockInfo[info.sn]
    delete state.hmsInfo[info.sn]
  },
  SET_OSD_VISIBLE_INFO (state, info) {
    state.osdVisible = info
  },
  SET_SELECT_WAYLINE_INFO (state, info) {
    state.waylineInfo = info
  },
  SET_SELECT_DOCK_INFO (state, info) {
    state.dockInfo = info
  },
  SET_SELECT_PILOT_INFO (state, info) {
    state.pilotInfo = info
  },
  SET_SELECT_ALGORITHM_INFO (state, info) {
    state.algorithmInfo = info
  },
  SET_SELECTED_SPECIAL_INFO (state, info) {
    state.specialInfo = info
  },
  SET_DEVICE_HMS_INFO (state, info) {
    const hmsList: Array<DeviceHms> = state.hmsInfo[info.sn]
    state.hmsInfo[info.sn] = info.host.concat(hmsList ?? [])
  },
  SET_DEVICES_CMD_EXECUTE_INFO (state, info) { // 保存设备指令ws消息推送
    if (!info.sn) {
      return
    }
    if (state.devicesCmdExecuteInfo[info.sn]) {
      const index = state.devicesCmdExecuteInfo[info.sn].findIndex(cmdExecuteInfo => cmdExecuteInfo.biz_code === info.biz_code)
      if (index >= 0) {
        // 丢弃前面的消息
        if (state.devicesCmdExecuteInfo[info.sn][index].timestamp > info.timestamp) {
          return
        }
        state.devicesCmdExecuteInfo[info.sn][index] = info
      } else {
        state.devicesCmdExecuteInfo[info.sn].push(info)
      }
    } else {
      state.devicesCmdExecuteInfo[info.sn] = [info]
    }
  },
  SET_MQTT_STATE (state, mqttState) {
    state.mqttState = mqttState
  },
  SET_CLIENT_ID (state, clientId) {
    state.clientId = clientId
  },
  SET_FLY_CONTROL (state, bool) {
    state.flyControl = bool
  },
  SET_ROUTES: (state, routers) => {
    state.addRoutes = routers
    state.routes = routes.concat(routers)
  },
  SET_DEFAULT_ROUTES: (state, routers) => {
    state.defaultRoutes = routes.concat(routers)
  },
  SET_TOPBAR_ROUTES: (state, routers) => {
    state.topbarRouters = routers
  },
  SET_TOPBAR_ROUTERS (state, routers) {
    state.topbarRouter = routers
  },
  SET_SIDEBAR_ROUTERS: (state, routers) => {
    state.sidebarRouters = routers
  },
  SET_SCENARIOS_SIDEBAR_ROUTERS: (state, routers) => {
    state.scenariosSidebarRouters = routers
  },
  SET_HOME_ROUTES (state, routers) {
    state.homeRoutes = routers
  },
  SET_LOGOUT (state) {
    state.addRoutes = []
    state.sidebarRouters = []
    state.topbarRouters = []
    state.routes = []
    state.defaultRoutes = []
    state.scenariosSidebarRouters = []
    state.homeRoutes = []
    state.hasAddedAsyncRoutes = false
  }
}

const actions: ActionTree<RootStateType, RootStateType> = {
  GenerateRoutes ({ commit, state }) {
    return new Promise(resolve => {
      // 向后端请求路由数据
      getRouters({ subSystem: 'control_system' }).then(res => {
        const sdata = JSON.parse(JSON.stringify(res.data))
        const rdata = JSON.parse(JSON.stringify(res.data))
        const hdata = JSON.parse(JSON.stringify(res.data))
        const sceData = JSON.parse(JSON.stringify(res.data))
        const liveData = JSON.parse(JSON.stringify(res.data))
        const defaultData = JSON.parse(JSON.stringify(res.data))
        const homeWorkData = JSON.parse(JSON.stringify(res.data))
        const topbarData = JSON.parse(JSON.stringify(res.data))
        const homeWork = filterAsyncKeyRouter(homeWorkData, 'home-work')
        const liveRoutes = filterAsyncKeyRouter(liveData, 'livestream')
        const sidebarRoutes = filterAsyncKeyRouter(sdata, 'user')
        let homeRoutes = filterAsyncKeyRouter(hdata, 'home-menu')
        const topbarRoutes = filterAsyncKeyRouter(rdata, 'top')
        topbarRoutes.unshift(...homeWork)
        homeRoutes.splice(1, 0, ...liveRoutes)
        homeRoutes = homeRoutes.sort((a, b) => b.sort - a.sort)
        const scenariosSidebarRouters = filterAsyncKeyRouter(sceData, 'scenario')
        const topbarRouters = filterAsyncKeyRouter(topbarData, 'topbar')
        let newRouter = filterAsyncRouterCustom(defaultData)
        const dynamicNewRoutes = mergeRoutes(newRouter, dynamicRoutes)
        // console.log(dynamicNewRoutes, 'dynamicNewRoutes')
        newRouter = dynamicRoutes.concat(newRouter)
        commit('SET_ROUTES', newRouter)
        commit('SET_SIDEBAR_ROUTERS', sidebarRoutes)
        commit('SET_HOME_ROUTES', homeRoutes)
        commit('SET_DEFAULT_ROUTES', res.data)
        commit('SET_TOPBAR_ROUTES', topbarRoutes)
        commit('SET_TOPBAR_ROUTERS', topbarRouters)
        commit('SET_SCENARIOS_SIDEBAR_ROUTERS', scenariosSidebarRouters)
        resolve(newRouter)
      })
    })
  },
  flyToPoint ({ state, commit }, { longitude, latitude }) {
    getNearestDeviceNew({ lon: longitude, lat: latitude }).then(res => {
      if (res.data && res.data.length > 0) {
        state.flyToPointRow.lon = longitude
        state.flyToPointRow.lat = latitude
        commit('SET_AIR_FLY_LIST', res.data)
        commit('SET_AIR_FLY', true)
      } else {
        message.error('附近5公里内无设备，请重新选择位置点')
      }
    })
  },
  async getMarkList ({ state, commit, dispatch }, workspaceId) {
    const result = await getNewElementGroupsReq({
      groupId: '',
      isDistributed: true
    })
    const row = result.data.find(el => el.workspace_id === workspaceId)
    const layerList = []
    result.data.forEach(item => {
      if (item.elements && item.elements.length > 0) {
        item.elements.forEach(child => {
          if (child.type === LayerType.Normal) return
          if (child.elements && child.elements.length > 0) {
            layerList.push(...child.elements)
          }
        })
      }
    })

    await dispatch('setLayerInfo', row.elements ?? [])
    if (layerList.length === 0) {
      commit('SET_MARK_LIST', [])
    } else {
      commit('SET_MARK_LIST', layerList)
    }
  },
  async getCloundModelList ({ commit }, workspaceId) {
    const result = await getNewCloudModel()
    commit('SET_CLOUD_MODEL', result.data)
  },
  async getCrawlerGetAll ({ commit }, workspaceId) {
    const result = await getCrawlerGetAll()
    if (result.data.length > 0) {
      result.data.forEach(item => {
        item.status = true
      })
      commit('SET_CRAWLER_LIST', result.data ?? [])
    }
  },
  async getCustumFlyList ({ commit }, workspaceId) {
    getFlightAreaListData().then((result) => {
      const apiData = result.data
      const workspaceList = apiData.map(workspace => ({
        workspace_id: workspace.workspace_id,
        workspace_name: workspace.workspace_name,
        flight_areas: workspace.flight_areas || []
      }))
      const list = []
      workspaceList.forEach(workspace => {
        if (workspace.flight_areas.length > 0) {
          workspace.flight_areas.forEach(item => {
            item.show = true
          })
          list.push(...workspace.flight_areas)
        }
      })
      if (workspaceList.length > 0) {
        commit('SET_WORKSPACE_LIST', workspaceList ?? [])
      }

      if (list.length > 0) {
        commit('SET_FLY_LIST', list ?? [])
      }
    })
  },
  async getAllElement ({ commit }) {
    const result = await getLayers({
      groupId: '',
      isDistributed: true
    })
    commit('SET_LAYER_INFO', result.data?.list)
    console.log(result)
  },
  getDevices ({ commit }, id) {
    getDeviceTopo(id).then((res) => {
      // console.log(res.data, 'getDeviceTopo')

      commit('SET_DOCK_DEVICE_LIST', res.data)
    })
  },
  updateElement ({ state }, content: { type: 'is_check' | 'is_select', id: string, bool: boolean }) {
    const key = content.id.replaceAll('resource__', '')
    const type = content.type
    const layers = state.Layers
    const layer = layers.find(item => item.id === key)
    if (layer) {
      layer[type] = content.bool
    }
  },
  setLayerInfo ({ state }, layers) {
    // const layers = state.Layers
    const obj: {
      [key: string]: string
    } = {}
    layers.forEach(layer => {
      if (layer.type === LayerType.Default) {
        obj.default = layer.id
      } else {
        if (layer.type === LayerType.Share) {
          obj.share = layer.id
        } else if (layer.type === LayerType.Normal) {
          obj.custom = layer.id
        }
      }
    })
    state.layerBaseInfo = obj
    // console.log('state.layerBaseInfo', state.layerBaseInfo)
  },
  getLayerInfo ({ state }, id: string) {
    return state.layerBaseInfo[id]
  }
}

function filterAsyncKeyRouter (asyncRouterMap, key) {
  const arr = []
  asyncRouterMap.forEach(item => {
    if (item.children && item.children.length > 0) {
      const list = filterAsyncKeyRouter(item.children, key)
      if (list.length > 0) {
        arr.push(...list)
      }
    }
    if (item.remark === key) {
      arr.push({
        path: item.path,
        icon: item.meta.icon,
        label: item.meta.title,
        hidden: item.hidden,
        key: item.path.startsWith('http') ? item.path.split('://')[1] : item.path.split('/')[1]
      })
    }
  })
  return arr
}

function filterAsyncRouterCustom (asyncRouterMap) {
  return asyncRouterMap.filter(route => {
    if (route.remark === 'scenarios') {
      route.component = SLayout
      if (route.redirect === 'noRedirect') {
        delete route.redirect
      }
    } else if (route.remark === 'scenarios-work') {
      route.component = SParentView
      route.redirect = route.children[0].path.startsWith('/') ? route.children[0].path : `${route.path}/${route.children[0].path}`
      route.children.push({
        path: '/scenario-plan-detail',
        name: 'ScenarioPlanDetail',
        component: ScenarioPaneDetail
      })
    } else if (route.remark === 'home') {
      route.component = Layout
      if (route.redirect === 'noRedirect') {
        delete route.redirect
      }
    } else if (route.remark === 'home-work') {
      route.component = ParentView
      route.redirect = route.children[0].path.startsWith('/') ? route.children[0].path : `${route.path}/${route.children[0].path}`
    } else if (route.remark === 'livestream') {
      route.component = loadView(route.component)
      route.children = [
        {
          path: ERouterName.LIVING,
          name: ERouterName.LIVING,
          components: {
            LiveAgora,
            LiveOthers
          }
        }
      ]
      if (route.redirect === 'noRedirect') {
        delete route.redirect
      }
    } else {
      if (route.path === '/scenario') {
        route.component = SLayout
        route.redirect = route.children[0].path.startsWith('/') ? route.children[0].path : `${route.path}/${route.children[0].path}`
      } else {
        route.component = loadView(route.component)
      }
      if (route.redirect === 'noRedirect') {
        delete route.redirect
      }
    }
    if (route.children && route.children.length > 0) {
      const children = filterAsyncRouterCustom(route.children)
      route.children = children
    }
    return true
  })
}

/**
 * 深度合并两个路由数组
 * @param {Array} routesA - 基准路由数组
 * @param {Array} routesB - 新路由数组（优先级更高）
 * @returns {Array} 合并后的路由数组
 */
function mergeRoutes (routesA, routesB) {
  // 复制一份原数组，避免修改原数据
  const result = JSON.parse(JSON.stringify(routesA || []));

  (routesB || []).forEach(routeB => {
    const existingIndex = result.findIndex(routeA => routeA.path === routeB.path)
    if (existingIndex !== -1) {
      // 相同路径：合并已有路由和新路由
      const existingRoute = result[existingIndex]
      // 合并 children
      if (routeB.children && existingRoute.children) {
        existingRoute.children = mergeRoutes(existingRoute.children, routeB.children)
      } else if (routeB.children) {
        existingRoute.children = JSON.parse(JSON.stringify(routeB.children))
      }
      // 合并顶层属性（新路由优先）
      Object.keys(routeB).forEach(key => {
        if (key !== 'children') {
          existingRoute[key] = routeB[key]
        }
      })
    } else {
      // 新增路由
      result.push(JSON.parse(JSON.stringify(routeB)))
    }
  })
  return result
}
// 动态路由遍历，验证是否具备权限
export function filterDynamicRoutes (routes) {
  const res = []
  routes.forEach(route => {
    if (route.permissions) {
      if (auth.hasPermiOr(route.permissions)) {
        res.push(route)
      }
    } else if (route.roles) {
      if (auth.hasRoleOr(route.roles)) {
        res.push(route)
      }
    }
  })
  return res
}

export const loadView = (view) => {
  let res
  for (const path in modules) {
    const dir = path.split('pages/')[1].split('.vue')[0]
    if ('/' + dir === view) {
      res = () => modules[path]()
    }
  }
  return res
}
const storeOptions: StoreOptions<RootStateType> = {
  state: initStateFunc,
  getters,
  mutations,
  actions
}

const rootStore = createStore(storeOptions)

// 告警通知
interface AlarmMessage {
  alarmMessage: string
  alarmTime: string
  alarmLevel: string
  alarmCode: string
  id: string
  read?: boolean
}
const alarmMsg = ref<AlarmMessage[]>([])
export const enableAlarmNotification = ref(false)

export const setAlarmMsg = (info: any) => {
  const parsedInfo = typeof info === 'string' ? JSON.parse(info) : info

  const filteredMsg: AlarmMessage = {
    alarmMessage: parsedInfo.alarmMessage || '',
    alarmTime: parsedInfo.alarmTime || '',
    alarmLevel: parsedInfo.alarmLevel || '',
    alarmCode: parsedInfo.alarmCode || '',
    id: parsedInfo.id || '',
    read: false // 默认未读
  }
  alarmMsg.value.unshift(filteredMsg)

  if (enableAlarmNotification.value) {
    notification.warning({
      message: '收到一条告警，请尽快处理',
      description: parsedInfo.alarmMessage,
    })
  }

  if (alarmMsg.value.length > 1) {
    alarmMsg.value.pop()
  }
}

export default rootStore

export const storeKey: InjectionKey<Store<RootStateType>> = Symbol('')

type AllStateStoreTypes = RootStateType & {
  // moduleName: moduleType
}

export function useMyStore<T = AllStateStoreTypes> () {
  return useStore<T>(storeKey)
}
